import React from 'react';
import { useNavigate } from 'react-router-dom';

function PageHeader({ title, subtitle }) {
  const navigate = useNavigate();

  return (
    <div className="sticky top-0 z-50 backdrop-blur-lg bg-white/70 shadow-sm">
      <div className="container mx-auto px-2 py-1">
        <div className="flex items-center">
          <button
            onClick={() => navigate('/')}
            className="mr-4 p-2 rounded-full hover:bg-gray-100 transition-colors"
            aria-label="返回主页"
          >
            <svg
              className="w-6 h-6 text-gray-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M10 19l-7-7m0 0l7-7m-7 7h18"
              />
            </svg>
          </button>
          <div>
            <h1 className="text-lg font-bold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="text-sm text-gray-500">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PageHeader; 